import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageBrokerService } from '../core/message-broker.service'
import { ErrorModel } from '../core/index';
import { Observable } from 'rxjs/Rx';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'error',
  template: require('./error.component.html')
})
export class ErrorComponent implements OnInit {
  error: ErrorModel = new ErrorModel();
  constructor(public route: ActivatedRoute, private _router: Router, private _messageBrokerService: MessageBrokerService) { }
  public ngOnInit() {
    this.subScribeErrorChanges();
  }
  reloadPage(): void {
    if (!this.error.shouldRefreshApp) {
      if (this.error.reloadRoute)
        this._router.navigateByUrl(this.error.reloadRoute);

      if (location.href.endsWith('error')) {
        this._router.navigateByUrl('/');
        return;
      }

      location.reload();
    }
    else {
      //the following forces the app to reload
      window.location.hash = "";  
      window.location.reload();
    }

  }
  ngOnDestroy() {
    if (this.errorSubscription){
      this.errorSubscription.unsubscribe();

    }
  }

  errorSubscription: Subscription;

  subScribeErrorChanges(): void {
    this.errorSubscription = this._messageBrokerService.getError().subscribe((error: ErrorModel) => {
      // console.error('ErrorComponent.subScribeErrorChanges():' + error);
      console.error('ErrorComponent.subScribeErrorChanges():' + JSON.stringify(error));
      if (error != null) {
        this.error = error;
      }
    });
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/helper-components/error.component.ts